import React, { useContext, useState } from "react";
import burger from "../../images/burger.svg";
import { ReactComponent as RedirectIcon } from "../../images/redirectIcon.svg";
import styled from "styled-components";
import { Label, FlexWrapper } from "../StyledComponents/StyledComponents";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import whiteRight from "../../images/whiteRight.svg";
import darkRight from "../../images/DarkRight.svg";
import cross from "../../images/cross.svg";
import { validURL, lightOrDark } from "../../Constants/utility";
import { SearchContext, KBContext } from "../../Context/index";
import MainLogo from "../../images/defaultLogo.png";
import { customizeNavigationButton, FTR_KB_FOR_OUTLOOK, PRODUCT_KB_ORIGIN } from "../../Constants/index";
import { isFeatureEnabled } from "../../utils";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { HIVER_GMAIL, NAVIGATION_BUTTON_TEXT, HIVER_OMNI, OUTLOOK_PRODUCT_TYPE, OMNI_PRODUCT_TYPE } from "../../Constants/KBContext.constants";

const HeaderWrapper = styled.header`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px 100px;

  @media screen and (max-width: 1100px) {
    margin: 20px 90px;
  }

  @media screen and (max-width: 800px) {
    margin: 20px 40px;
  }

  @media screen and (max-width: 500px) {
    margin: 20px 24px;
  }

  transition: margin 1s;
`;

const LogoWrapper = styled.img`
  max-width: 160px;
  max-height: 50px;
  cursor: pointer;
`;
const BurgerImage = styled.img`
  max-width: 20px;
  max-height: 20px;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const DropDownWrappper = styled.div`
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const RightImage = styled.img`
  height: 9.55px;
  width: 5.83px;
`;
const DropDownContent = styled.div`
  width: 85%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.138889px;
  cursor: pointer;
  color: ${(props) => props.color};
`;

const DropDownContainer = styled.div`
  box-sizing: border-box;
  max-height: 150px;
  background-color: ${(props) => props.backColor};
`;

const Modal = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 95px;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);

  @media screen and (max-width: 500px) {
    top: 85px;
  }

  @media (min-width: 769px) {
    display: none;
  }

  transition: top 1s;
`;

const HeaderNavigation = styled.div`
  margin-left: 40px;
`;
const BorderLine = styled.div`
  background: #313c4b;
  border-radius: 9px;
  height: 2px;
  margin-top: 2px;
`;

const GmailOutlookButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

const GmailOutlookButton = styled.button`
  display: ${({ hidden }) => hidden ? "none" : "flex"};
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border: 1px solid #196fe0;
  border-radius: 4px;
  margin-right: 40px;
  padding: 0 18px;
  min-height: 36px;
  background-color: #ffffff;
  color: #196fe0;
  font-size: 14px;
  font-weight: 500px;
  line-height: 28px;
  font-family: Poppins;
  svg {
    width: 16px;
    fill: #196fe0;
  }
  &:hover {
    color: #ffffff;
    background-color: #0456c2;
    border-color: #0456c2;
    svg {
      fill: #ffffff;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

// Old CustomizedNavigationButton (Open Sans, dynamic bannerTextColor, 4px padding)
const LegacyCustomizedNavigationButton = styled.div`
  padding: 4px 20px;
  cursor: pointer;
  color: ${(props) => props.bannerData?.bannerTextColor};
  background: ${(props) => props.bannerData?.brandColor};
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.2px;
  border-radius: 4px;
  min-width: 64px;
`;

export default function LegacyHeader({ bannerData }) {
  const { setSearchInput, setSearchList } = useContext(SearchContext);
  const { search, pathname } = useLocation();
  const navigate = useNavigateWithSearch();
  const [searchParams] = useSearchParams();
  const Image_Base_Url = process.env.REACT_APP_IMAGE_BASE_URL;
  const [openDropDown, setOpenDropDown] = useState(false);
  const { availableFeatures } = useContext(KBContext);
  const showCustomizedNavigationButton = isFeatureEnabled(customizeNavigationButton, availableFeatures);
  const showSwitchKbButton = isFeatureEnabled(FTR_KB_FOR_OUTLOOK, availableFeatures);
  const handleBurgerClick = () => {
    setOpenDropDown(!openDropDown);
  };
  const product = searchParams.get("product");
  const buttonText = NAVIGATION_BUTTON_TEXT.replace("{{product}}", [OUTLOOK_PRODUCT_TYPE, OMNI_PRODUCT_TYPE].includes(product) ? HIVER_GMAIL : HIVER_OMNI);
  const showButton = showSwitchKbButton && window.origin === PRODUCT_KB_ORIGIN;
  const buttonHref = [OUTLOOK_PRODUCT_TYPE, OMNI_PRODUCT_TYPE].includes(product) ? PRODUCT_KB_ORIGIN
    : `${PRODUCT_KB_ORIGIN}?product=${OMNI_PRODUCT_TYPE}`;

  const logoSrc = bannerData && bannerData?.logo !== "default"
    ? Image_Base_Url + bannerData.logo
    : MainLogo;

  const handleNavigationClicked = (url) => {
    if (validURL(url)) {
      if (url.includes("http://") || url.includes("https://")) {
        window.open(url, "_blank");
      } else {
        let httpUrl = "https://";
        window.open(httpUrl.concat(url), "_blank");
      }
    }
  };
  const navigateToAltKB = () => {
    window.open(buttonHref, "_blank");
  }

  return (
    <>
      <HeaderWrapper>
        <GmailOutlookButtonWrapper>
          <LogoWrapper
            onClick={() => {
              setSearchInput("");
              setSearchList([]);
              navigate("/");
            }}
            src={logoSrc}
          />
          <GmailOutlookButton hidden={!showButton} onClick={navigateToAltKB}>{buttonText}<RedirectIcon /></GmailOutlookButton>
        </GmailOutlookButtonWrapper>
        <FlexWrapper width="auto" hide align="center" justify="center">
          {bannerData?.enableHelpForm && (
            <HeaderNavigation>
              <Link to={"/submit-issue" + search} style={{ textDecoration: "none" }}>
                <Label
                  className={
                    pathname === "/submit-issue"
                      ? "headerLabelSelect"
                      : "headerLabel"
                  }
                >
                  {bannerData?.helpPageName}
                </Label>
              </Link>
              {pathname === "/submit-issue" && <BorderLine />}
            </HeaderNavigation>
          )}
          {!!Object.keys(availableFeatures).length && bannerData?.navigationButtonText && (
            <HeaderNavigation>
              { showCustomizedNavigationButton ?
                <LegacyCustomizedNavigationButton
                  bannerData={bannerData}
                  onClick={() =>
                    handleNavigationClicked(bannerData?.navigationButtonUrl)
                  }
                >
                  {bannerData.navigationButtonText}
                </LegacyCustomizedNavigationButton> :
                <Label
                  onClick={() =>
                    handleNavigationClicked(bannerData?.navigationButtonUrl)
                  }
                  className="headerLabel"
                >
                  {bannerData.navigationButtonText}
                </Label>
              }
            </HeaderNavigation>
          )}
        </FlexWrapper>
        {(bannerData?.enableHelpForm || bannerData?.navigationButtonText) && (
          <BurgerImage
            onClick={handleBurgerClick}
            src={openDropDown ? cross : burger}
          />
        )}
      </HeaderWrapper>
      {openDropDown && (
        <Modal>
          <DropDownContainer
            backColor={
              bannerData ? bannerData?.brandColor : "rgba(20, 115, 230, 1)"
            }
          >
            {bannerData?.enableHelpForm && (
              <DropDownWrappper>
                <DropDownContent
                  color={
                    lightOrDark(bannerData?.brandColor) === "light"
                      ? "#222222"
                      : "#FFFFFF"
                  }
                  onClick={() => navigate("/submit-issue")}
                >
                  Submit an Issue
                  <RightImage
                    src={
                      lightOrDark(bannerData?.brandColor) === "light"
                        ? whiteRight
                        : darkRight
                    }
                  />
                </DropDownContent>
              </DropDownWrappper>
            )}
            {bannerData.navigationButtonText && (
              
                <DropDownWrappper
                  onClick={() =>
                    handleNavigationClicked(bannerData?.navigationButtonUrl)
                  }
                >
                  <DropDownContent
                    color={
                      lightOrDark(bannerData?.brandColor) === "light"
                        ? "#222222"
                        : "#FFFFFF"
                    }
                  >
                    {bannerData.navigationButtonText}
                    <RightImage
                      src={
                        lightOrDark(bannerData?.brandColor) === "light"
                          ? whiteRight
                          : darkRight
                      }
                    />
                  </DropDownContent>
                </DropDownWrappper>
            )}
          </DropDownContainer>
        </Modal>
      )}
    </>
  );
}
